import React, {Component} from 'react';
import {Button,} from "antd";
import {getLeasingRevenue} from "../../appRedux/actions";
import {connect} from "react-redux";
import './style.css';

class Revenue extends Component {
    constructor(props) {
        super(props);
        this.state = {
            revenue: {},
            load: {},
            cachedRevenue: null,
        }
    }

    componentDidMount() {
        if (this.props.id) {
            const allRevenue = this.props.allRevenue;
            if (!allRevenue[this.props.id])
                this.props.getLeasingRevenue(this.props.id);
            else {
                this.setState({
                    cachedRevenue: allRevenue[this.props.id]
                })
            }

        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (!this.state.cachedRevenue && prevProps.revenue !== this.props.revenue) {
            // console.log('3. ', prevProps, this.props);
            let rvn = this.state.revenue;
            let ld = this.state.load;
            if (this.props.revenue !== null && this.props.revenue.revenue !== null) {
                rvn[this.props.revenue.id] = this.props.revenue.revenue;
                ld[this.props.revenue.id] = this.props.revenue.loading;
                this.setState({
                    revenue: rvn,
                    load: ld,
                })

                this.props.addRevenueToRecord(this.props.id, {
                    revenue: rvn,
                    load: ld,
                })
            }
        }
    }

    onClick = (asset) => {
        if (asset) {
            // const win = window.open(`asset/history-report/${this.props.id}`, "_blank");
            // win.focus();
        }
    }

    render() {
        const {revenue, load} = this.state;
        return (
            <div>
                {this.state.cachedRevenue ?
                    <Button style={{width: '150px'}} size={'small'} shape="round" loading={false}
                            onClick={() => this.onClick(this.props.id)}>
                        {this.state.cachedRevenue.revenue[this.props.id] >= 0 && this.state.cachedRevenue.revenue[this.props.id].toLocaleString('en-IN', {
                            maximumFractionDigits: 2,
                            style: 'currency',
                            currency: 'INR'
                        }) || <span>&#8377;0.00</span>}
                    </Button>
                    :
                    <Button style={{width: '150px'}} size={'small'} shape="round" loading={load[this.props.id]}
                            onClick={() => this.onClick(this.props.id)}>
                        {revenue[this.props.id] >= 0 && revenue[this.props.id].toLocaleString('en-IN', {
                            maximumFractionDigits: 2,
                            style: 'currency',
                            currency: 'INR'
                        }) || <span>&#8377;0.00</span>}
                    </Button>
                }
            </div>
        );
    }
}


const mapStateToProps = ({auth, leasing}) => {
    return {
        authUser: auth.authUser,
        revenue: leasing.assetRevenue,
    }
};

function mapDispatchToProps(dispatch) {
    return {
        getLeasingRevenue
    };
}

export default connect(mapStateToProps, mapDispatchToProps())(Revenue);
